import * as React from 'react';
import { css, styled } from 'styled-components';
import { Row } from '../layout/flex-containers';

type StatusBarProps = React.HTMLAttributes<HTMLDivElement> & {
  visible: boolean;
  SvgIcon?: React.FC<React.SVGProps<SVGElement>>;
};

const StatusBar: React.FC<StatusBarProps> = ({
  visible,
  SvgIcon,
  children,
  ...divProps
}) => (
  <Bar role="alert" $visible={visible} {...divProps}>
    {SvgIcon && <SvgIcon width="12" height="12" className="mx-2" aria-hidden />}
    {children}
  </Bar>
);

const Bar = styled(Row)<{ $visible: boolean }>`
  justify-content: center;
  align-items: center;
  background-color: var(--neutral-16);
  color: var(--neutral-1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;

  transform: translate3d(0, -2rem, 0);
  opacity: 0;

  transition:
    transform 250ms ease-in-out,
    background-color 500ms ease-out;

  ${({ $visible }) =>
    $visible &&
    css`
      opacity: 1;
      transform: translate3d(0, 0, 0);
    `}
`;

export default StatusBar;
